import React, { useEffect, useState } from 'react';
import { Chip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { getRequest } from 'utils/api';
import { openModal } from 'features/utilsSlice';
import { formatGigPrice } from 'utils/helpers';
import ChevronRight from 'public/icons/chevron-right-grey.svg';
import CompletePaymentDialog from 'components/gigs/payment/CompletePaymentDialog';
import styles from 'styles/components/ToDos.module.scss';

const UnfundedGigTodos = () => {
  const [unfundedGigs, setUnfundedGigs] = useState([]);
  const [gig, setGig] = useState({});
  const dispatch = useDispatch();

  const handleClick = gig => {
    dispatch(openModal({ name: 'Complete Gig Payment' }));
    setGig(gig);
  };

  const handleListUpdate = gig =>
    setUnfundedGigs(prevGigs => prevGigs.filter(prevGig => prevGig.id !== gig.id));

  useEffect(() => {
    let isMounted = true;

    getRequest({
      endpoint: 'gigs',
      query: { status: 'active' },
    })
      .then(response => {
        if (!isMounted) return;
        const unfundedGigs = response.filter(gig => !gig.funded);
        setUnfundedGigs(unfundedGigs);
      })
      .catch(() => {});

    return () => (isMounted = false);
  }, []);

  if (unfundedGigs.length === 0) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      {unfundedGigs
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map(gig => (
          <div className={styles.card} onClick={() => handleClick(gig)} key={gig.id}>
            <div className={styles.column}>
              <div className={styles.indicator} style={{ backgroundColor: '#ff4b4b' }} />

              <div style={{ paddingLeft: 10, marginRight: 'auto' }}>
                <h3>Not Funded Gig</h3>
                <p>You need to finalize the payment</p>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={styles.column}>
                <Chip label="Not Funded" color="secondary" className={styles.chip} />
                <ChevronRight />
              </div>

              <div
                className={styles.price}
                style={{ marginBottom: 0, marginRight: 25, marginTop: 5 }}
              >
                {formatGigPrice(gig, gig.total_amount)}
              </div>
            </div>
          </div>
        ))}

      {!isEmpty(gig) && <CompletePaymentDialog gig={gig} handleListUpdate={handleListUpdate} />}
    </div>
  );
};

export default UnfundedGigTodos;
